import React, {ReactNode} from 'react';
import {hasFeatureFlag} from '../../forecast-app/shared/util/FeatureUtil';
import {TooltipFormulaRenderer} from '@/components/TooltipFormulaRenderer';
import {Tooltip} from '@forecast-it/design-system';
import {useIntl, type IntlShape} from 'react-intl';

export type TooltipItem = {
	title?: string;
	description?: string | ReactNode;
	details?: string[];
};

type FinancialCategoryTooltipProps = React.PropsWithChildren<{
	items: TooltipItem[];
	size?: string;
}>;

export const FinancialCategoryTooltip = ({items, size, children}: FinancialCategoryTooltipProps): React.JSX.Element => {
	const hasFinancialCategories = hasFeatureFlag('financial_categories_update');
	if (!hasFinancialCategories || !items || items.length === 0) {
		return <>{children}</>;
	}

	return (
		<Tooltip width={size ? size : 'm'} content={<TooltipFormulaRenderer items={items} />} interactable={false}>
			{children}
		</Tooltip>
	);
};

export const createFinancialCategoryTooltip = (itemsFn: (formatMessage: IntlShape['formatMessage']) => TooltipItem[]) => {
	return (props: Omit<FinancialCategoryTooltipProps, 'items'>): React.JSX.Element => {
		const {formatMessage} = useIntl();
		return <FinancialCategoryTooltip {...props} items={itemsFn(formatMessage)} />;
	};
};
